import React from 'react';
import {
  StyleSheet,
  View,
  Text,
  StyleProp,
  ViewStyle,
  TextStyle,
} from 'react-native';

export type BadgeProps = {
  containerStyle?: StyleProp<ViewStyle>;
  textStyle?: StyleProp<TextStyle>;
  text: string;
  color: string;
};

export const Badge: React.FC<BadgeProps> = ({
  containerStyle,
  textStyle,
  text,
  color,
}) => {
  const containerColorStyle = {borderWidth: 1, borderColor: color};
  const textColorStyle = {color};
  return (
    <View style={[styles.container, containerColorStyle, containerStyle || {}]}>
      <Text style={[styles.text, textColorStyle, textStyle || {}]}>{text}</Text>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    paddingHorizontal: 8,
    paddingVertical: 4,
    borderRadius: 4,
  },
  text: {
    fontSize: 12,
    fontWeight: '600',
    textAlign: 'center',
  },
});
